import { Container, Row, Col, Button } from "react-bootstrap";
import SocialIcons from '../../components/socialicons';
import Skills from "../../components/skills";

const Home = () => {
    return (
      <Container className="my-5">
        <Row className="justify-content-center align-items-center">
          {/* Coluna com a apresentação principal */}
          <Col lg={12} className="text-start mb-5 mb-lg-0">
            <div className="mb-4">
              <h1 className="display-4 text-center text-color-site text-font-family">
                Everton Souza
              </h1>
              <h2 className="h3 mb-4 text-center" style={{ color: '#adb5bd' }}>
                Full Stack Developer | Desenvolvedor Back-end | Arquitetura | DevOps | Cloud | Leitor Ávido
              </h2>
              

              <div className="mb-5 d-flex justify-content-center">
                <div className="p-3" style={{ maxWidth: "720px", width: "100%" }}>

                  <h3 className="text-center text-color-site text-font-family mb-4">
                    Uma Breve Apresentação
                  </h3>

                  <p className="lead text-color-site text-font-family text-center mb-3">
                    <strong>Quase 20 anos de experiência em TI</strong>, com foco em
                    análise e desenvolvimento de software.
                  </p>

                  <p className="text-color-site text-font-family text-center mb-3">
                    Durante essa jornada, participei de projetos em diversos segmentos,
                    colaborando com equipes multidisciplinares e entregando soluções de alta criticidade.
                  </p>

                  <p className="text-color-site text-font-family text-center mb-4">
                    Minha atuação envolve desde tecnologias clássicas até ferramentas modernas em nuvem,
                    arquiteturas escaláveis e práticas de DevOps.
                  </p>

                  <p className="text-color-site text-font-family text-center mb-0">
                    Aqui você vai encontrar ideias de projetos que utilizamos como laboratório
                    para testar novas tecnologias e explorar toda a esteira de desenvolvimento.
                  </p>

                </div>
                </div>

              <div className="mb-3">
                <h3 className="display-6 text-center text-color-site text-font-family">Principais Qualificações</h3>
                <Skills />
              </div>
              
              <div className="social-links mb-5 social-padding"> 
                <h3 className="mb-5 display-6 text-center text-color-site text-font-family">Contatos</h3>
                <SocialIcons />
              </div>
            </div>
          </Col>
          
          
        </Row>
      </Container>
    );
}

export default Home;